import { useState } from 'react';
import { MediaLibraryList } from '../../components/MediaLibraryList';
import './MediaLibraryPage.scss';
import { MediaUpload } from '../../components/MediaUpload';
import { useMediaLibrary } from '../../contexts/MediaLibraryContext';

export const MediaLibraryPage = () => {
  const [showMediaUpload, setShowMediaUpload] = useState(false);
  const { mediaLibraryData, loading, error, refreshMediaLibrary } = useMediaLibrary();

  const handleMediaUpload = () => {
    setShowMediaUpload(!showMediaUpload);
  };

  if (loading && mediaLibraryData.images.length === 0) {
    return (
      <div className="mediaLibraryPage">
        <div>Loading media library...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mediaLibraryPage">
        <div>Error: {error}</div>
        <button onClick={refreshMediaLibrary}>Retry</button>
      </div>
    );
  }

  return (
    <>
      <div className="mediaLibraryPage">
        <MediaLibraryList 
          mediaLibraryData={mediaLibraryData} 
          loading={loading}
          onUpload={handleMediaUpload}
        />
      </div>
      {showMediaUpload && (
        <MediaUpload 
          onUpload={handleMediaUpload} 
          onSuccess={refreshMediaLibrary}
        />
      )}
    </>
  );
}; 